export const SUPPORTED_LANGUAGES = ['en', 'nl', 'de', 'fr', 'es', 'el', 'it', 'pt', 'tr'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export function isSupportedLanguage(value: string | null | undefined): value is SupportedLanguage {
  return value != null && (SUPPORTED_LANGUAGES as readonly string[]).includes(value);
}

/**
 * `i18next-browser-languagedetector` caches its *own* detection result
 * (browser language, or the `fallbackLng`) into `localStorage.i18nextLng` on
 * every `init()` — before this app has ever loaded `/me` or shown a language
 * switcher. So that key alone can't tell "the visitor picked a language"
 * apart from "the detector guessed one". This separate flag is set only by
 * `LanguageSwitcher`, and is what `MeContext`'s profile-language effect
 * checks before overriding with `me.user.preferred_language` — giving the
 * intended priority: manual choice > profile preference > browser > `en`.
 */
const MANUAL_CHOICE_KEY = 'i18nextLng-manual';

export function hasManualLanguageChoice(): boolean {
  try {
    return localStorage.getItem(MANUAL_CHOICE_KEY) != null;
  } catch {
    return false;
  }
}

export function markManualLanguageChoice(): void {
  try {
    localStorage.setItem(MANUAL_CHOICE_KEY, '1');
  } catch {
    // Storage can be unavailable (private browsing, disabled cookies). The
    // language still changes for this session; it just won't be
    // remembered as "manual" for a later profile-preference check.
  }
}
